import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-notifications-skeleton',
  standalone: true,
  imports: [
    SkeletonModule
  ],
  templateUrl: './notifications-skeleton.component.html',
  styleUrl: './notifications-skeleton.component.scss'
})
export class NotificationsSkeletonComponent {

}
